<template>
  <div class="all-settings">
    <base-header class="pb-6">
      <b-row class="py-3">
        <b-col lg="6" cols="7">
          <h2 class="text-xl d-inline-block mb-0">All Templates</h2>
          <p class="text-muted">All tempates for send sms, email & notification to users.</p>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <el-tabs>
        <el-tab-pane label="SMS Template">
          <SmsTemplatesTable />
        </el-tab-pane>
        <el-tab-pane label="Email Template">
          <EmailTemplatesTable />
        </el-tab-pane>
      </el-tabs>
    </b-container>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import SmsTemplatesTable from '@/views/AllSettings/TemplatePages/SmsTemplates/SmsTemplatesTable'
import EmailTemplatesTable from '@/views/AllSettings/TemplatePages/EmailTemplates/EmailTemplatesTable'

export default {
  components: {
    SmsTemplatesTable,
    EmailTemplatesTable,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  }
}
</script>